module.exports = __webpack_public_path__ + "img/矩形备份14@1x.1d3ef0ce.png";